<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <div class="footer-logo">
            <img v-if="companyInfo && companyInfo.logoUrl" :src="companyInfo.logoUrl" alt="Logo" class="logo">
            <h3>{{ companyInfo ? companyInfo.companyName : '倾至城科技' }}</h3>
          </div>
          <p class="footer-description">
            {{ companyInfo ? companyInfo.description : '专注于科技创新和数字化转型的高新技术企业' }}
          </p>
          <div class="social-links">
            <a href="#" class="social-link">
              <i class="el-icon-message"></i>
            </a>
            <a href="#" class="social-link">
              <i class="el-icon-phone"></i>
            </a>
            <a href="#" class="social-link">
              <i class="el-icon-link"></i>
            </a>
          </div>
        </div>

        <div class="footer-section">
          <h4>快速导航</h4>
          <ul class="footer-links">
            <li><router-link to="/">首页</router-link></li>
            <li><router-link to="/about">关于我们</router-link></li>
            <li><router-link to="/products">产品服务</router-link></li>
            <li><router-link to="/news">新闻动态</router-link></li>
            <li><router-link to="/contact">联系我们</router-link></li>
          </ul>
        </div>

        <div class="footer-section">
          <h4>产品服务</h4>
          <ul class="footer-links">
            <li><a href="#">软件开发</a></li>
            <li><a href="#">技术咨询</a></li>
            <li><a href="#">系统集成</a></li>
            <li><a href="#">数据分析</a></li>
            <li><a href="#">人工智能</a></li>
          </ul>
        </div>

        <div class="footer-section">
          <h4>联系信息</h4>
          <div class="contact-info">
            <div class="contact-item">
              <i class="el-icon-location"></i>
              <span>{{ companyInfo ? companyInfo.address : '上海市浦东新区张江高科技园区' }}</span>
            </div>
            <div class="contact-item">
              <i class="el-icon-phone"></i>
              <span>{{ companyInfo ? companyInfo.phone : '021-12345678' }}</span>
            </div>
            <div class="contact-item">
              <i class="el-icon-message"></i>
              <span>{{ companyInfo ? companyInfo.email : 'contact@qzctech.com' }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="footer-copyright">
          <p>&copy; {{ currentYear }} {{ companyInfo ? companyInfo.companyName : '上海倾至城科技有限公司' }}. 保留所有权利.</p>
        </div>
        <div class="footer-links-bottom">
          <a href="#">隐私政策</a>
          <a href="#">服务条款</a>
          <a href="#">网站地图</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Footer',
  computed: {
    ...mapState(['companyInfo']),
    currentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
  padding: 60px 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 40px;
  margin-bottom: 40px;
}

.footer-section {
  h3, h4 {
    margin-bottom: 20px;
    font-weight: 600;
  }

  h3 {
    font-size: 1.3rem;
  }

  h4 {
    font-size: 1.1rem;
    color: #ecf0f1;
  }
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;

  .logo {
    height: 40px;
  }

  h3 {
    color: white;
    margin: 0;
  }
}

.footer-description {
  font-size: 0.9rem;
  line-height: 1.6;
  color: #bdc3c7;
  margin-bottom: 20px;
}

.social-links {
  display: flex;
  gap: 12px;
}

.social-link {
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-decoration: none;
  transition: $transition-base;

  &:hover {
    background: $primary-color;
    transform: translateY(-2px);
  }

  i {
    font-size: 16px;
  }
}

.footer-links {
  list-style: none;

  li {
    margin-bottom: 8px;

    a {
      color: #bdc3c7;
      text-decoration: none;
      font-size: 0.9rem;
      transition: $transition-base;

      &:hover {
        color: $primary-color;
      }
    }
  }
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: #bdc3c7;

  i {
    font-size: 14px;
    color: $primary-color;
  }
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-copyright {
  p {
    font-size: 0.85rem;
    color: #95a5a6;
    margin: 0;
  }
}

.footer-links-bottom {
  display: flex;
  gap: 20px;

  a {
    color: #95a5a6;
    text-decoration: none;
    font-size: 0.85rem;
    transition: $transition-base;

    &:hover {
      color: $primary-color;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .footer {
    padding: 40px 0 20px;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }

  .footer-links-bottom {
    justify-content: center;
  }
}
</style>
